// let baseUrl = `${window.location.protocol}//${window.location.host}`;
// if (baseUrl.includes("localhost")) baseUrl = "http://localhost:3000";
// // if (baseUrl.includes("localhost")) baseUrl = "https://dev-paiyhub.4pay.ca";
// export var serviceUrl = baseUrl + "/php/Workflows/services.php?output=json";
// export var LOANS_ACCOUNT_NO = 16334;


let baseUrl = `${window.location.protocol}//${window.location.host}`;

if (baseUrl.includes("localhost")) {
  // Point directly to your working WAMP setup
  baseUrl = "http://paiy.local"; 
}

export var serviceUrl = baseUrl + "/php/Workflows/services.php?output=json";
export var LOANS_ACCOUNT_NO = 16334;